import React from "react";
import style from "./YoutubeVideo.module.scss";
import { useSignal } from "@preact/signals-react";
import backSvg from "../ShoppingProduct/backBtn.svg";
import ReactPlayer from "react-player/youtube";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
export function YoutubeVideo(props) {
  var isVideoPlaying = useSignal(false);
  function playVideo() {
    isVideoPlaying.value = true;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: style.youtubeVideoBox
  }, /*#__PURE__*/React.createElement("div", {
    className: style.video
  }, props.isFromList && /*#__PURE__*/React.createElement("div", {
    className: style.backIcon,
    onClick: props.back
  }, /*#__PURE__*/React.createElement("img", {
    src: backSvg
  })), /*#__PURE__*/React.createElement(ReactPlayer, {
    url: props.url,
    width: "100%",
    height: "100%",
    playing: isVideoPlaying.value,
    controls: true,
    light: true,
    playIcon: /*#__PURE__*/React.createElement("img", {
      className: style.playBtn,
      src: "".concat(settings.S3CDN).concat(settings.viewAssetsPath, "vb-play.png")
    }),
    onClickPreview: playVideo
  })), /*#__PURE__*/React.createElement("div", {
    className: style.videoInfo
  }, /*#__PURE__*/React.createElement("p", {
    className: style.videoTitle
  }, props.video_title), /*#__PURE__*/React.createElement("div", {
    className: style.videoBrand
  }, /*#__PURE__*/React.createElement("img", {
    src: props.source.source_icon
  }), /*#__PURE__*/React.createElement("span", null, props.source.source_text))));
}